import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from 'react-select';
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import SelectComp from "../../NewComponent/Select/Select";


export default function SelectSourceComponentOverview() {
	const userState = useSelector((state)=>state.user);
	const dispatch = useDispatch();
	const {getSourceValueInOverview} = bindActionCreators(Actions,dispatch)
	const array1 = Object.values(userState.questionAllowedSources).map((label,value,name)=>{return {label:label,value:value}});
	const obj1 = {label:'All Source',value:array1.map((obj,ind)=>{return ind}).toString()}
	const expertOverview = useSelector((state) => state.expertOverviewCmReducer)
	array1.unshift(obj1);
	const newObj = {
		"0": "Vizerto",
		"2": "Mobile",
		"3": "slack",
		"4": "email",
		"5": "slack-channel",
		"9": "webex",
		"10": "webex-channel"
	}
	const array2 = Object.entries(userState.questionAllowedSources).map((([label,value])=>{return {value:parseInt(label),label:value}}))
	const values = array2.map((item)=>item.value)

	// const array3 = array2.map((ob,ind)=>{return Object.keys(ob).map((o,i)=>{return Object.values(ob[`value`])})})
	// console.log(array3,'check array 3 values')
	// const obj2 = {label:'All Source',value:array2.map((obj,ind)=>{return Object.keys(obj.label).map((ob)=>parseInt(ob)) })}
	// console.log(obj2, 'check object 2 2222')

	const allSourceObject = {
		value: values.toString(),
		label: "All Source"
	};

	array2.unshift(allSourceObject)
	console.log(array2,'check if all source has been added')



	const customStyles = {
		control: (base, state) => ({
			...base,
			fontSize: 13,
			marginBottom:0,
			minHeight: 32,
			height: 32,
			borderColor: state.isFocused ? 'none' : null,
			minWidth: 120,
			border: '1px solid lightgrey',
			boxShadow: 'none',
			border: state.isFocused ? '1px solid lightgrey' : '1px solid lightgrey',
			"&:hover": { border: '1px solid lighgrey' }
		}),
		menuList: (base) => ({
			...base,
			fontSize: 13,
			padding: 0
		}),
		option: (base, state) => ({
			...base,
			backgroundColor: (state.isSelected && 'var(--viz_light_color)'),
			"&:hover": { backgroundColor: state.isSelected ? null : '#ececec' },
			cursor: 'pointer',
			textTransform:'capitalize'
		}),
		dropdownIndicator: (styles) => ({
			...styles,
			paddingTop: 0,
			paddingBottom: 0,
			color: "lightgray",
		  }),
		  clearIndicator: (styles) => ({
			...styles,
			paddingTop: 0,
			paddingBottom: 0,
			color: "lightgray",
		  }),
	};

	const onChangeData = (data) => {
		getSourceValueInOverview(data)
	}
	return (
		<>
			{/* <Select
				className="basic-single"
				classNamePrefix="select"
				defaultValue={array2[0]}
				isDisabled={false}
				isClearable={false}
				isSearchable={true}
				name="color"
				options={array2}
				styles={customStyles}
				onChange={onChangeData}
				value={expertOverview.source}
			/> */}
			<SelectComp isString={false} width={'100%'} onChangeFunc={onChangeData} options={array2} val={expertOverview.source} labelInValue={true} />
		</>
	)
}